export const buildTree = (data, parentId) => {
  const children = data.filter((item) => item.parent_id === parentId);
  return children.map((child) => ({
    ...child,
    children: buildTree(data, child.id),
  }));
};

export const sortByPosition = () => {
  return function (elem1, elem2) {
    if (elem1.position < elem2.position) return -1;
    if (elem1.position > elem2.position) return 1;
    return 0;
  };
};

export const generateRandomToken = (length) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    token += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return token;
};
